<template>
  <header>
    <div class="container">
      <a class="logo" title="E.ON" href="/" id="logo"></a>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>
